import React from 'react';
import { PlacesAutocomplete } from '../../../ui';

interface PlacesAutocompleteInputProps {
  id: string;
  placeholder: string;
  defaultValue: string;
  onChange: (place: any) => void;
  isDisabled?: boolean;
}

export const PlacesAutocompleteInput: React.FC<
  PlacesAutocompleteInputProps
> = ({ id, placeholder, defaultValue, onChange, isDisabled }) => (
  <PlacesAutocomplete
    id={id}
    placeholder={placeholder}
    defaultValue={defaultValue}
    onSelectChange={onChange}
    disabled={isDisabled}
  />
);
